module.exports = __webpack_public_path__ + "static/media/galeryCeilings7.2559a532.jpg";